class DescribeDocumentTemplateFile {
	constructor(public readonly file: File) {
		Object.freeze(this);
	}
}

export default DescribeDocumentTemplateFile;
